import { Button, Modal, notification, Switch, Table } from "antd";
import { useEffect, useState } from "react";
import {
  useOrganizationUserDelete,
  useOrganizationUsers,
} from "../../api/Organizations";
import { useUserMutation } from "../../api/Users";
import UserDisplay from "../../components/UserDisplay";
import { ContentTitle } from "../../layout/ContentLayout";
import { displayUserName } from "../../utils/userUtil";

const Users = ({ organizationId }) => {
  const [users, setUsers] = useState([]);
  const { data } = useOrganizationUsers(organizationId);

  const columns = [
    {
      title: "User",
      key: "User",
      render: (_, user) => <UserDisplay user={user} size={50} fullDetails />,
    },
    {
      title: "Action",
      key: "action",
      render: (_, user) => <ToggleUserRole user={user} />,
    },
    {
      title: "Remove",
      key: "remove",
      render: (_, user) => (
        <RemoveUser user={user} organizationId={organizationId} />
      ),
    },
  ];

  useEffect(() => {
    if (data?.Users) {
      setUsers(
        data.Users.map((u) => {
          return {
            key: u.UserId,
            UserId: u.UserId,
            Email: u.Email,
            FirstName: u.FirstName,
            LastName: u.LastName,
            Avatar: u.Avatar,
            Roles: u.Roles,
          };
        })
      );
    }
  }, [data]);
  return (
    <>
      <ContentTitle>Users</ContentTitle>
      <Table dataSource={users} columns={columns} />
    </>
  );
};

const RemoveUser = ({ user, organizationId }) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const removeUser = useOrganizationUserDelete(organizationId, user.UserId);

  const remove = () => {
    setSubmitting(true);
    removeUser
      .mutateAsync()
      .then((r) => {
        notification.success({
          message: "Success",
          description: `${displayUserName(
            user
          )} has been removed from your organization`,
        });
        setShowPrompt(false);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <>
      <Button danger size="small" onClick={() => setShowPrompt(true)}>
        Remove
      </Button>
      <Modal
        open={showPrompt}
        onCancel={() => setShowPrompt(false)}
        title={`Remove ${displayUserName(user)}?`}
        closable={false}
        footer={[
          <Button disabled={submitting} onClick={() => setShowPrompt(false)}>
            Cancel
          </Button>,
          <Button
            disabled={submitting}
            danger
            type="primary"
            onClick={() => remove()}
          >
            Remove
          </Button>,
        ]}
      >
        <p>This action cannot be undone.</p>
      </Modal>
    </>
  );
};

const ToggleUserRole = ({ user }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const userUpdate = useUserMutation(user.UserId);

  useEffect(() => {
    const { Roles } = user;
    setIsAdmin(Roles.some((u) => u === "organization_admin"));
  }, [user]);

  const changeAdmin = () => {
    setSubmitting(true);
    let roles = !isAdmin
      ? [...user.Roles, "organization_admin"]
      : user.Roles.filter((r) => r !== "organization_admin");
    userUpdate
      .mutateAsync({ Roles: roles })
      .then((r) => {
        setIsAdmin(!isAdmin);
        setSubmitting(false);
        notification.success({
          message: "Success",
          description: "Role changed",
        });
      })
      .catch(() => {
        setSubmitting(false);
        notification.error({
          message: "Something went wrong",
          description: "Please try again",
        });
      });
  };

  return (
    <Switch
      size="small"
      checked={isAdmin}
      onChange={() => changeAdmin()}
      disabled={submitting}
    />
  );
};

export default Users;
